import { useSelector } from 'react-redux';

import { statsLeadersNavSelector } from 'store/modules/statspro/stats-leaders/selectors';

export const useCompAbbrProvider = () => {
    const nav = useSelector(statsLeadersNavSelector);
    const seasons = nav?.seasons;

    // If the nav.season.id is not defined (example: the stats are showing the career stats)
    // takes the latest season from the list (ordered by ID descending)
    let compSeason;

    if (typeof nav.season.id === 'undefined' || nav.season.id === -1) {
        compSeason = seasons
            .filter((season) => season.currentRoundNumber > 0)
            .sort((seasonA, seasonB) => (seasonA.id < seasonB.id ? 1 : -1))[0];
    } else {
        compSeason = seasons?.find(
            (season) => season.id.toString() === nav.season.id.toString()
        );
    }

    return PULSE.app.common.match.getCompAbbr(compSeason?.providerId);
};
